/**
 * Smaller first-load limit to improve initial dashboard and navigator responsiveness.
 */
export const DEFAULT_PATIENT_LIST_LIMIT = 250;

/**
 * Broad "All" scope limit; loaded lazily only when clinicians explicitly open All.
 */
export const ALL_PATIENT_LIST_LIMIT = 700;
